<!-- eslint-disable @angular-eslint/template/no-call-expression -->
@let piece = piece$ | async;
<ng-container>
  <render-slice
    *ngIf="isSlice(piece)"
    [attr.data-id]="pieceId(piece)"
    [slice]="piece">
  </render-slice>

  <render-piece
    *ngIf="!isSlice(piece) && (settings$ | async)"
    [attr.data-id]="pieceId(piece)"
    [piece]="piece"
    [settings]="settings$ | async"
    [country]="country$ | async"
    [lang]="lang$ | async"
    [slot]="currentSlot">
  </render-piece>
</ng-container>
